import type { Avatar } from "../types";

const fetchAvatars = async (): Promise<Avatar[]> => {
	return [];
};

export { fetchAvatars };
